/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getVaccinationSchedules } from 'app/entities/vaccination-schedule/vaccination-schedule.reducer';
import { getEntities as getVaccinations } from 'app/entities/vaccination/vaccination.reducer';
import { createEntity, getEntity, reset, updateEntity } from './vaccination-schedule-details.reducer';

export const VaccinationScheduleDetailsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const vaccinationSchedules = useAppSelector(state => state.vaccinationSchedule.entities);
  const vaccinations = useAppSelector(state => state.vaccination.entities);
  const vaccinationScheduleDetailsEntity = useAppSelector(state => state.vaccinationScheduleDetails.entity);
  const loading = useAppSelector(state => state.vaccinationScheduleDetails.loading);
  const updating = useAppSelector(state => state.vaccinationScheduleDetails.updating);
  const updateSuccess = useAppSelector(state => state.vaccinationScheduleDetails.updateSuccess);

  const handleClose = () => {
    navigate(`/vaccination-schedule-details${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getVaccinationSchedules({}));
    dispatch(getVaccinations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.ageMax !== undefined && typeof values.ageMax !== 'number') {
      values.ageMax = Number(values.ageMax);
    }
    if (values.ageMin !== undefined && typeof values.ageMin !== 'number') {
      values.ageMin = Number(values.ageMin);
    }
    if (values.periodInDays !== undefined && typeof values.periodInDays !== 'number') {
      values.periodInDays = Number(values.periodInDays);
    }
    if (values.forYear !== undefined && typeof values.forYear !== 'number') {
      values.forYear = Number(values.forYear);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...vaccinationScheduleDetailsEntity,
      ...values,
      schedule: vaccinationSchedules.find(it => it.id.toString() === values.schedule?.toString()),
      vacciantion: vaccinations.find(it => it.id.toString() === values.vacciantion?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...vaccinationScheduleDetailsEntity,
          schedule: vaccinationScheduleDetailsEntity?.schedule?.id,
          vacciantion: vaccinationScheduleDetailsEntity?.vacciantion?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.vaccinationScheduleDetails.home.createOrEditLabel"
            data-cy="VaccinationScheduleDetailsCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.home.createOrEditLabel">
              Create or edit a VaccinationScheduleDetails
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="vaccination-schedule-details-id"
                  label={translate('tinyMedicRestApp.vaccinationScheduleDetails.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.active')}
                id="vaccination-schedule-details-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.ageMax')}
                id="vaccination-schedule-details-ageMax"
                name="ageMax"
                data-cy="ageMax"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.ageMin')}
                id="vaccination-schedule-details-ageMin"
                name="ageMin"
                data-cy="ageMin"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.country')}
                id="vaccination-schedule-details-country"
                name="country"
                data-cy="country"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.dosage')}
                id="vaccination-schedule-details-dosage"
                name="dosage"
                data-cy="dosage"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.gender')}
                id="vaccination-schedule-details-gender"
                name="gender"
                data-cy="gender"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.periodInDays')}
                id="vaccination-schedule-details-periodInDays"
                name="periodInDays"
                data-cy="periodInDays"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.risk')}
                id="vaccination-schedule-details-risk"
                name="risk"
                data-cy="risk"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.vaccinationTypeCd')}
                id="vaccination-schedule-details-vaccinationTypeCd"
                name="vaccinationTypeCd"
                data-cy="vaccinationTypeCd"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.forYear')}
                id="vaccination-schedule-details-forYear"
                name="forYear"
                data-cy="forYear"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.timestampentry')}
                id="vaccination-schedule-details-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.microSec')}
                id="vaccination-schedule-details-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.lastupdated')}
                id="vaccination-schedule-details-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.cursor')}
                id="vaccination-schedule-details-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="vaccination-schedule-details-schedule"
                name="schedule"
                data-cy="schedule"
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.schedule')}
                type="select"
                required
              >
                <option value="" key="0" />
                {vaccinationSchedules
                  ? vaccinationSchedules.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="vaccination-schedule-details-vacciantion"
                name="vacciantion"
                data-cy="vacciantion"
                label={translate('tinyMedicRestApp.vaccinationScheduleDetails.vacciantion')}
                type="select"
                required
              >
                <option value="" key="0" />
                {vaccinations
                  ? vaccinations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/vaccination-schedule-details"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default VaccinationScheduleDetailsUpdate;
